document.addEventListener('collection:reloaded', function() {
    // Collection has reloaded after filters applied
  if (window.location.search) {    
      const searchParams = new URLSearchParams(window.location.search);
      let gtagParams = {};
      let brand;
      let price = [];
      let count = 0;
      for (const p of searchParams) {
          count = p[0].includes("filter") ? count + 1: count;
          if (p[0].includes("filter.v.price")){
              switch (p[0].includes("gte")) {
                  case true:
                      price.push("greater than")
                      break;
              
                  default:
                      price.push("less than")
                      break;
              }
          }
          brand = (p[0] == "filter.p.vendor") ? p[1] : null;
          let key = p[0].match(/^filter\.p\.m.+/s) != null ? p[0].match(/^filter\.p\.m.+/s)[0].replace("filter.p.m.custom.", ''): null;
          let value = key != null ? p[1] : null;
          if (key != null) {
              key in gtagParams ? gtagParams[key].push(value) : gtagParams[key] = [value];
          }
      }
      price = price.length > 1 ? "range"
          : price.length > 0 
          ? price[0]
          : null;
  
      gtag('event', 'filter_use',
          {
              'event_category': 'behaviour',
              'filters_price': price,
              'filters_brand': brand,
              'filters': gtagParams,
              'value': count,
              'send_to': "GTM-54JKXBP"
          }
          
      )
  };
});